import api from '../../../dependencies/utils/Api';

import {
    DOWNLOAD_DPIIT_REPORT,
} from '../../../constants/ApplicationUrl';

export const startup80iacReportService = {

    downloadReport(params) {
        return api.DOWNLOADDATA(`${DOWNLOAD_DPIIT_REPORT}`,params).
            then((data) => {
                return data;
            }).catch(e => {
                return Promise.reject(e);
            })
    }
}